/* =========================================================================
   Orivé Málaga — Claude restyle (gedrag)
   1. Sticky "Añadir al carrito"-balk: toont/verbergt zichzelf o.b.v. scroll
      en spiegelt prijs + voorraadstatus van de echte koopknop. Een klik
      triggert gewoon de bestaande koopknop, zodat alle validatie/AJAX-
      logica van het thema blijft werken.
   2. Reviews-carrousel: voegt paginatie-dots toe aan de "¿Qué dicen
      nuestras clientas?"-sectie zodat je kunt swipen/klikken, net als op
      de voorbeeldpagina's.
   3. Mobiele header: verplaatst het zoekicoon naast het menu-icoon
      (MENU | ZOEKEN | LOGO | WINKELMANDJE), alleen onder 768px.
   Toegevoegd door Claude, sep 2026.
   ========================================================================= */
(function () {
  'use strict';

  function initStickyAddToCart() {
    var bars = document.querySelectorAll('[data-sticky-atc]');
    if (!bars.length) return;

    bars.forEach(function (bar) {
      var formId = bar.getAttribute('data-target-form');
      var form = formId ? document.getElementById(formId) : null;
      if (!form) return;

      var realBtn = form.querySelector('[data-add-to-cart]');
      var stickyBtn = bar.querySelector('[data-sticky-atc-btn]');
      var priceEl = bar.querySelector('[data-sticky-atc-price]');
      var imgEl = bar.querySelector('[data-sticky-atc-image]');

      if (stickyBtn && realBtn) {
        stickyBtn.addEventListener('click', function () {
          if (realBtn.disabled) return;
          realBtn.click();
        });
      }

      function syncDisabledState() {
        if (!realBtn || !stickyBtn) return;
        if (realBtn.disabled) {
          stickyBtn.setAttribute('disabled', 'disabled');
        } else {
          stickyBtn.removeAttribute('disabled');
        }
      }
      syncDisabledState();
      if (realBtn && 'MutationObserver' in window) {
        new MutationObserver(syncDisabledState).observe(realBtn, {
          attributes: true,
          attributeFilter: ['disabled']
        });
      }

      var priceSourceCurrent = document.querySelector('[data-product-price]');
      var priceWrap = document.querySelector('[data-product-price-wrap]');
      var priceSourceCompare = document.querySelector('[data-compare-price]');

      function syncPrice() {
        if (!priceEl || !priceSourceCurrent) return;
        var currentHTML = priceSourceCurrent.textContent.trim();
        var compareVisible = priceWrap && !priceWrap.classList.contains('hide');
        var compareHTML = compareVisible && priceSourceCompare ? priceSourceCompare.textContent.trim() : '';
        var html = '';
        if (compareHTML) {
          html += '<span class="sticky-atc__price-compare">' + compareHTML + '</span>';
        }
        html += '<span class="sticky-atc__price-current">' + currentHTML + '</span>';
        priceEl.innerHTML = html;
      }
      if (priceSourceCurrent && 'MutationObserver' in window) {
        syncPrice();
        var priceObserver = new MutationObserver(syncPrice);
        priceObserver.observe(priceSourceCurrent, { characterData: true, childList: true, subtree: true });
        if (priceWrap) {
          priceObserver.observe(priceWrap, { attributes: true, attributeFilter: ['class'] });
        }
      }

      // Beste poging: wissel de miniatuur in de sticky balk als een
      // kleurstaal met eigen foto wordt aangeklikt.
      document.querySelectorAll('[data-color-name]').forEach(function (input) {
        input.addEventListener('change', function () {
          if (!imgEl) return;
          var labelEl = document.querySelector('label[for="' + input.id + '"] img');
          if (labelEl) {
            imgEl.src = labelEl.src;
          }
        });
      });

      var target = realBtn || form;
      if (target && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            if (pastButton) {
              bar.removeAttribute('hidden');
              requestAnimationFrame(function () {
                bar.classList.add('sticky-atc--visible');
              });
            } else {
              bar.classList.remove('sticky-atc--visible');
              window.setTimeout(function () {
                if (!bar.classList.contains('sticky-atc--visible')) {
                  bar.setAttribute('hidden', '');
                }
              }, 250);
            }
          });
        }, { threshold: 0 });
        io.observe(target);
      }
    });
  }

  function initTestimonialDots() {
    var wraps = document.querySelectorAll('[class*="testimonials-scrolling-wrap-"]');
    if (!wraps.length) return;

    wraps.forEach(function (wrap) {
      if (wrap.dataset.dotsInit) return;

      var list = wrap.querySelector('[class*="testimonials-scrolling-list-"]');
      if (!list) return;

      var slides = Array.prototype.filter.call(list.children, function (el) {
        var cls = el.className || '';
        return cls.indexOf('testimonials-slide-') !== -1;
      });
      if (slides.length < 2) return;

      wrap.dataset.dotsInit = 'true';

      var dotsWrap = document.createElement('div');
      dotsWrap.className = 'testimonials-dots';

      slides.forEach(function (slide, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'testimonials-dots__dot' + (index === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Reseña ' + (index + 1));
        dot.addEventListener('click', function () {
          wrap.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
      });

      wrap.parentElement.insertBefore(dotsWrap, wrap.nextSibling);

      var dots = dotsWrap.querySelectorAll('.testimonials-dots__dot');
      var ticking = false;

      function updateActiveDot() {
        var scrollCenter = wrap.scrollLeft + wrap.clientWidth / 2;
        var best = 0;
        var bestDist = Infinity;
        slides.forEach(function (slide, index) {
          var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          var dist = Math.abs(slideCenter - scrollCenter);
          if (dist < bestDist) {
            bestDist = dist;
            best = index;
          }
        });
        dots.forEach(function (dot, index) {
          dot.classList.toggle('is-active', index === best);
        });
      }

      wrap.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          updateActiveDot();
          ticking = false;
        });
      });
    });
  }

  function initMobileSearchReorder() {
    // Header-layout is "center-drawer": menu-icoon zit in .header-item--navigation,
    // zoekicoon zit in .header-item--icons (twee aparte flex-containers, dus CSS
    // "order" alleen kan de volgorde niet over die grens heen wijzigen). Op mobiel
    // verplaatsen we het zoekicoon-element naar naast het menu-icoon, zodat de
    // volgorde MENU | ZOEKEN | LOGO | WINKELMANDJE wordt. Op desktop (>=768px)
    // zetten we het terug naar zijn oorspronkelijke plek, dus daar verandert niets.
    var searchLink = document.querySelector('.header-item--icons .js-search-header');
    var navWrap = document.querySelector('.header-item--navigation .site-nav');
    if (!searchLink || !navWrap) return;

    var originalParent = searchLink.parentElement;
    var originalNext = searchLink.nextSibling;
    var mql = window.matchMedia('(max-width: 767px)');

    function apply(isMobile) {
      if (isMobile) {
        if (searchLink.parentElement !== navWrap) {
          navWrap.appendChild(searchLink);
        }
      } else if (searchLink.parentElement !== originalParent) {
        if (originalNext && originalNext.parentElement === originalParent) {
          originalParent.insertBefore(searchLink, originalNext);
        } else {
          originalParent.appendChild(searchLink);
        }
      }
    }

    apply(mql.matches);

    if (mql.addEventListener) {
      mql.addEventListener('change', function (e) { apply(e.matches); });
    } else if (mql.addListener) {
      // Oudere Safari-versies
      mql.addListener(function (e) { apply(e.matches); });
    }
  }

  function init() {
    initStickyAddToCart();
    initTestimonialDots();
    initMobileSearchReorder();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
